import {Component,OnInit,ViewChild} from '@angular/core';
import {FormulaireOmService} from './formulaire-om.service';
import {IdModeDegrevementOption,IdModeParticipantOption,IdTraiteAvantLeOption,ParamOm} from '@domain/admin/parametre/formulaire/param-om';
import {BehaviorSubject} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {NgForm} from "@angular/forms";

/**
 * Composant d'affichage de la page Formulaire de l'Om
 *
 * @author Lionel Gimenez
 * @date 08/09/2025
 */
@Component({
    host: {'data-test-id': 'formulaire-om'},
    selector: 'formulaire-om',
    templateUrl: './formulaire-om.component.html',
})
export class FormulaireOmComponent implements OnInit {
    /** Déclaration pour le template */
    IdModeParticipantOption = IdModeParticipantOption;

    /** Liste des options pour idTraiteAvantLe */
    idTraiteAvantLeOptionListe: Array<{ value: IdTraiteAvantLeOption,libelle: string }> = [];

    /** Liste des options pour idModeParticipant */
    idModeParticipantOptionListe: Array<{ value: IdModeParticipantOption,libelle: string }> = [];

    /** Liste des options pour idModeDegrevement */
    idModeDegrevementOptionListe: Array<{ value: IdModeDegrevementOption,libelle: string }> = [];

    /** Liste des actions */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /** Formulaire */
    @ViewChild('form') form: NgForm;

    /**
     * Constructeur
     */
    constructor(
        public formulaireOmService: FormulaireOmService,
        private translateService: TranslateService,
    ) {

    }

    /**
     * Hook initialisation
     */
    ngOnInit(): void {
        //Initialisation des listes d'options
        this.initOptionsListes();

        //Initialisation des actions
        this.initActions();

        //Chargement des données
        this.formulaireOmService.load();
    }

    /**
     * Initialise les listes d'options pour les sélecteurs
     */
    private initOptionsListes(): void {
        //Options pour idTraiteAvantLe
        this.idTraiteAvantLeOptionListe = [
            {value: IdTraiteAvantLeOption.NonRenseigne,libelle: this.translateService.instant('admin.parametres.formulaire.om.valeurDefautOption.nonRenseigne')},
            {value: IdTraiteAvantLeOption.DateDuJour,libelle: this.translateService.instant('admin.parametres.formulaire.om.valeurDefautOption.dateDuJour')},
            {value: IdTraiteAvantLeOption.DateDebutMission,libelle: this.translateService.instant('admin.parametres.formulaire.om.valeurDefautOption.dateDebutMission')},
            {value: IdTraiteAvantLeOption.VeilleDepartMission,libelle: this.translateService.instant('admin.parametres.formulaire.om.valeurDefautOption.veilleDepartMission')}
        ];

        //Options pour idModeParticipant
        this.idModeParticipantOptionListe = [
            {value: IdModeParticipantOption.INTERNES_ET_EXTERNES,libelle: this.translateService.instant('admin.parametres.formulaire.om.participantAutorisationOption.internesEtExternes')},
            {value: IdModeParticipantOption.INTERNES_UNIQUEMENT,libelle: this.translateService.instant('admin.parametres.formulaire.om.participantAutorisationOption.internesUniquement')},
            {value: IdModeParticipantOption.EXTERNES_UNIQUEMENT,libelle: this.translateService.instant('admin.parametres.formulaire.om.participantAutorisationOption.externesUniquement')},
            {value: IdModeParticipantOption.AUCUN,libelle: this.translateService.instant('admin.parametres.formulaire.om.participantAutorisationOption.aucun')}
        ];

        //Options pour idModeDegrevement
        this.idModeDegrevementOptionListe = [
            {value: IdModeDegrevementOption.AUCUNE,libelle: this.translateService.instant('admin.parametres.formulaire.om.indemniteDegrevementOption.aucune')},
            {value: IdModeDegrevementOption.DETAILLE,libelle: this.translateService.instant('admin.parametres.formulaire.om.indemniteDegrevementOption.detaille')}
        ];
    }

    /**
     * Initialise les actions du bouton flottant
     */
    private initActions(): void {
        this.listeActions.next([
            {
                type: TypeAction.PRIMARY,
                icone: 'nio icon-sauvegarde',
                libelle: 'global.actions.enregistrer',
                doAction: () => this.save(),
                isDisabled: () => this.form?.invalid || !this.formulaireOmService.paramOM || this.isValeurDefautError(this.formulaireOmService.paramOM)
            }
        ]);
    }

    /**
     * Sauvegarde les paramètres
     */
    save(): void {
        this.formulaireOmService.save();
    }

    /**
     * Handler de changement de l'option idModeParticipant
     */
    onIdModeParticipantChange(idModeParticipant: IdModeParticipantOption) {
        //Raz des champs selon la sélection
        switch (idModeParticipant) {
            case IdModeParticipantOption.AUCUN:
                this.formulaireOmService.paramOM.collabNotPartAlowwed = false;
                this.formulaireOmService.paramOM.creationForParticipant = false;
                this.formulaireOmService.paramOM.emissionForParticipant = false;
                break;
            case IdModeParticipantOption.EXTERNES_UNIQUEMENT:
                this.formulaireOmService.paramOM.creationForParticipant = false;
                this.formulaireOmService.paramOM.emissionForParticipant = false;
                break;
        }
    }

    /**
     * Vérifie si une erreur est présente sur le champ valeurDefaut<br>
	 * Si la date n'est pas modifiable, la valeur par défaut doit être renseignée
     */
    isValeurDefautError(paramOm: ParamOm) {
        return paramOm?.idTraiteAvantLe === IdTraiteAvantLeOption.NonRenseigne
            && !paramOm.dateModifiable;
    }

    /**
     * Handler de changement de l'option dateObligatoire
     */
    onDateObligatoireChange() {
        this.formulaireOmService.paramOM.dateModifiable = false;
    }
}